import type { CatalogAssetResponse } from "../../generated/api/types.gen";
import { SourceAssetSwatch } from "./SourceAssetSwatch";

interface SourceAssetCardProps {
  asset: CatalogAssetResponse;
  onSave: (assetId: string) => void;
  onShowDetails: (assetId: string) => void;
}

const CTA =
  "rounded border border-[#3c7ca5] px-3 py-0.5 text-[9px] leading-5 font-medium whitespace-nowrap text-white transition-colors hover:bg-[#3c7ca5]";

/**
 * One manufacturer product on the Source screen: swatch or photo with its
 * catalog category, the maker and name, and the details and save actions.
 */
export function SourceAssetCard({
  asset,
  onSave,
  onShowDetails,
}: SourceAssetCardProps) {
  const isSaved = asset.in_library;

  return (
    <li
      aria-label={asset.name}
      className="flex flex-col overflow-hidden rounded-lg drop-shadow-[0_0_2px_rgba(32,38,44,0.6)]"
    >
      <SourceAssetSwatch asset={asset} className="h-[171px]" />
      <div className="flex flex-col gap-3 p-3">
        <div className="flex min-w-0 flex-col leading-5 text-(--text-primary)">
          <span className="truncate text-[11px] font-medium">
            {asset.manufacturer}
          </span>
          <span className="truncate text-[15px] font-bold" title={asset.name}>
            {asset.name}
          </span>
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => onShowDetails(asset.id)}
            className={`flex-1 bg-[rgba(60,124,165,0.25)] ${CTA}`}
          >
            See Details
          </button>
          <button
            type="button"
            onClick={() => onSave(asset.id)}
            disabled={isSaved}
            className={`bg-[rgba(54,112,149,0.75)] disabled:cursor-default disabled:bg-[rgba(60,124,165,0.25)] disabled:hover:bg-[rgba(60,124,165,0.25)] ${CTA}`}
          >
            {isSaved ? "Saved" : "Save to Asset"}
          </button>
        </div>
      </div>
    </li>
  );
}
